import {AfterViewInit, Directive, OnInit, Input, ChangeDetectorRef, Optional} from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import Inputmask from 'inputmask';
import {NgControl} from '@angular/forms';

@Directive({
  selector: 'nz-date-picker[maskDate]',
})
export class MaskDateDirective implements OnInit, AfterViewInit {
  @Input() min: string;
  @Input() max: string;

  constructor(
    private el: NzDatePickerComponent,
    @Optional() ngControl: NgControl
    ) {
  }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.changeFormat();
  }

  changeFormat() {
    switch(this.el.nzMode) {
      case 'date':
        this.el.nzFormat = this.el.nzLocale.lang.dateFormat;
        break;
      case 'week':
        // this.el.nzFormat = this.el.nzLocale.lang.monthFormat;
        return;
      case 'month':
        this.el.nzFormat = this.el.nzLocale.lang.monthFormat;
        break;
      case 'year':
        this.el.nzFormat = this.el.nzLocale.lang.yearFormat;
        break;
      default:
        return;
    }
    this.setInputMask();
  }

  setInputMask() {
    Inputmask('datetime', {
      inputFormat: this.el.nzFormat.toLowerCase(),
      placeholder: this.el.nzFormat.replace(/[^\/]/gi, '_'),
      // min: this.min ? this.min : '',
      // max: this.max ? this.max : '',
      clearMaskOnLostFocus: true,
      isComplete: function (buffer: any, opts: any) {
        return true;
      },
    }).mask(this.el.pickerInput?.nativeElement as HTMLElement);
  }
}
